<mat-chip-set [attr.data-test]="'selected-city-items'">
  @for (item of alert?.recipients?.municipals?.cities; track $index) {
    <mat-chip
      class="selected chip-text-color-inherit"
      [removable]="false"
      [attr.data-test]="'city'"
      [attr.data-testid]="item.cityName">
      {{ item.cityName + ', ' + item.stateCode }}
    </mat-chip>
  } @empty {
    <mat-chip class="empty chip-text-color-inherit" disabled="true">{{
      'None Found' | translate: locale.language
    }}</mat-chip>
  }
</mat-chip-set>
@for (layer of alert?.recipients?.municipals?.sendTo; track $index) {
  <div style="padding-top: 0.5rem" [attr.data-test]="'municipal-layer'" [attr.data-testid]="layer.Name">
    <strong class="layer-title">{{ layer.Name }}:</strong>
    <span>
      <br />
      &nbsp; {{ 'RecipientCount' | translate: locale.language }}: {{ getLayerRecipientCount(layer) }}
    </span>
  </div>
}
